import React, { useState, useEffect } from "react";
import axios from "axios";
import "./CandidateForm.css";

const CandidateForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    age: "",
    dob: "",
    gender: "",
    fathername: "",
    address: "",
    aadhar: "",
    caste: "",
    native: "",
    language: "",
    qualification: "",
    identificationmark: "",
    referrencename: "",
    referenceno: "",
    experience: "",
    typeofwork: "",
    modeofwork: "",
    dateofjoining: "",
    stay: "",
    image: null,
    date: new Date().toISOString().split("T")[0], // Current date
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // const handleFileChange = (e) => {
  //   setFormData({ ...formData, image: e.target.files[0] });
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = new FormData();
    for (const key in formData) {
      form.append(key, formData[key]);
    }
    try {
      await axios.post(
        "https://api.dremerz.net/api/Project_17_ManPowerWebsite_Candidate_Aplication_Form",
        form,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      alert("Form submitted successfully!");
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  useEffect(() => {
    const element = document.getElementById("candidate");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  return (
    <div id="candidate">
      <div style={{ textAlign: "center" }} className="mt-5">
        <h2 className="ServicesCard-title mt-2">
          Need To Join Work Fill Up Submit Here{" "}
        </h2>
        <p className="ServicesCard-subtitle mt-2">
          Our Team Will Get Bact To You Soon
        </p>
      </div>

      <div className="CandidateForm-container">
        <form className="CandidateForm-form" onSubmit={handleSubmit}>
          <h2 className="CandidateForm-title">Candidate Form</h2>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label style={{marginTop: "10px"}} htmlFor="name">Your Name <span style={{color: "red"}}>*</span></label>
              <input
                type="text"
                className="form-control"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-md-6 mb-3">
              <label style={{marginTop: "10px"}} htmlFor="number">Mobile Number <span style={{color: "red"}}>*</span></label>
              <input
                type="text"
                className="form-control"
                id="number"
                maxLength={10}
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-md-6 mb-3">
              <label style={{marginTop: "10px"}} htmlFor="age">Age <span style={{color: "red"}}>*</span></label>
              <input
                type="number"
                className="form-control"
                id="age"
                name="age"
                value={formData.age}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-md-6 mb-3">
              <label style={{marginTop: "10px"}} htmlFor="dob">DOB</label>
              <input
                type="date"
                className="form-control"
                id="dob"
                name="dob"
                value={formData.dob}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6 mb-3">
              <label style={{marginTop: "10px"}} htmlFor="gender">Choose Gender</label>
              <select
                className="form-control"
                name="gender"
                id="gender"
                value={formData.gender}
                onChange={handleChange}
              >
                <option value=""></option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </select>
            </div>
            <div className="col-md-6 mb-3">
              <label style={{marginTop: "10px"}} htmlFor="fathername">Father/Husband Name</label>
              <input
                type="text"
                id="fathername"
                className="form-control"
                name="fathername"
                value={formData.fathername}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6 mb-3">
              <label style={{marginTop: "10px"}} htmlFor="address">Permanent Address <span style={{color: "red"}}>*</span></label>
              <input
                type="text"
                className="form-control"
                id="address"
                name="address"
                value={formData.address}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-md-6 mb-3">
              <label style={{marginTop: "10px"}} htmlFor="aadhar">Aadhar Number</label>
              <input
                type="text"
                className="form-control"
                id="aadhar"
                name="aadhar"
                value={formData.aadhar}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6 mb-3">
              <label style={{marginTop: "10px"}} htmlFor="caste">Caste/Religion</label>
              <input
                type="text"
                className="form-control"
                id="caste"
                name="caste"
                value={formData.caste}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6 mb-3">
              <label style={{marginTop: "10px"}} htmlFor="native">Native Place</label>
              <input
                type="text"
                className="form-control"
                id="native"
                name="native"
                value={formData.native}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6 mb-3">
              <label style={{marginTop: "10px"}} htmlFor="language">Language Known</label>
              <input
                type="text"
                className="form-control"
                id="language"
                name="language"
                value={formData.language}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6 mb-3">
              <label style={{marginTop: "10px"}} htmlFor="qualification">Qualification</label>
              <input
                type="text"
                className="form-control"
                id="qualification"
                name="qualification"
                value={formData.qualification}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6 mb-3">
              <label style={{marginTop: "10px"}} htmlFor="identificationmark">Identification Mark</label>
              <input
                type="text"
                className="form-control"
                id="identificationmark"
                name="identificationmark"
                value={formData.identificationmark}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6 mb-3">
              <label style={{marginTop: "10px"}} htmlFor="referrencename">Reference Name</label>
              <input
                type="text"
                className="form-control"
                id="referrencename"
                name="referrencename"
                value={formData.referrencename}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6 mb-3">
              <label style={{marginTop: "10px"}} htmlFor="referenceno">Reference Number</label>
              <input
                type="text"
                className="form-control"
                id="referenceno"
                name="referenceno"
                value={formData.referenceno}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6 mb-3">
              <label style={{marginTop: "10px"}} htmlFor="experience">Experience</label>
              <input
                type="text"
                className="form-control"
                id="experience"
                name="experience"
                value={formData.experience}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6 mb-3">
              <label style={{marginTop: "10px"}} htmlFor="typeofwork">Type of Work</label>
              <input
                type="text"
                className="form-control"
                id="typeofwork"
                name="typeofwork"
                value={formData.typeofwork}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6 mb-3">
              <label style={{marginTop: "10px"}} htmlFor="modeofwork">Mode of Work</label>
              <input
                type="text"
                className="form-control"
                id="modeofwork"
                name="modeofwork"
                value={formData.modeofwork}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6 mb-3">
              <label style={{marginTop: "10px"}} htmlFor="dateofjoining">Date of Joining</label>
              <input
                type="date"
                className="form-control"
                id="dateofjoining"
                name="dateofjoining"
                value={formData.dateofjoining}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6 mb-3">
              <label style={{marginTop: "10px"}} htmlFor="stay">Stay or No Stay</label>
              <input
                type="text"
                className="form-control"
                id="stay"
                name="stay"
                value={formData.stay}
                onChange={handleChange}
              />
            </div>
            {/* <div className="col-md-6 mb-3">
              <input
                type="file"
                className="form-control"
                name="image"
                onChange={handleFileChange}
                required
              />
            </div> */}
          </div>
          <button type="submit" className="CandidateForm-button">
            Submit <span>&#10145;</span>
          </button>
        </form>
      </div>
    </div>
  );
};

export default CandidateForm;
